<template>
<div>

  <Drawer v-model="dialog" :mask-closable="false" width="880" @on-close="closeDialog">
    <div slot="header">
      <strong v-if="loadedIn==='CancelClientInvoices'">Create Invoice</strong>
      <strong v-else>Reject Invoice</strong>
    </div>
    <div slot="close"><Icon size="20" class="close-icon" type="md-close" @click="closeDialog"/></div>
    <div class="drawer-body">
      <charges-summary :clientInvoiceId="clientInvoiceId" ref="charges-summary-comp"/>
    </div>
    <div class="drawer-footer">
      <Button v-if="loadedIn==='CancelClientInvoices'" @click="confirmCreateAction" :loading="loading" type="primary" size="large">CREATE INVOICE</Button>
      <Button v-else  @click="confirmDeclineAction" :loading="loading" type="primary" size="large">REJECT INVOICE</Button>
      <Button class="close-btn" size="large" @click="closeDialog">CLOSE</Button>
    </div>
  </Drawer>

</div>
</template>

<script>
import {Constants} from "../../../Constants/Constant";
import moment from 'moment';
import ChargesSummary from "../ChargesSummary";
import updateRecord from '../../../mixins/updateRecord';
let user = JSON.parse(localStorage.tatkalorri).userObj.user;
export default {
  name: "DeclineAction",
  components: {ChargesSummary},
  props: ['dialog', 'clientInvoiceId', 'loadedIn'],
  mixins: [updateRecord],
  data(){
    return{
      Constants: Constants,
      moment: moment,
      loading: false
    }
  },
  methods:{
    confirmDeclineAction(){
      this.$Modal.confirm({
        title: 'Confirm Rejection Request',
        content: `<p>Are you Sure, you want to reject ?</p><p style="margin: 4px 0 0 0; font-size: 14px">Rejecting this request will move invoice to Create Client Invoices module</p>`,
        onOk: async () => {
          this.updateClientInvoiceStatus();
        },
        onCancel: () => {}
      })
    },
    confirmCreateAction(){              /* For Canceled Client Invoices module */
      this.$Modal.confirm({
        title: 'Confirm Create Request',
        content: `<p>Are you Sure, you want to create ?</p><p style="margin: 4px 0 0 0; font-size: 14px">Approving this request will move invoice to Create Client Invoices module</p>`,
        onOk: async () => {
          this.updateClientInvoiceStatus();
        },
        onCancel: () => {}
      })
    },
    async updateClientInvoiceStatus(){
      this.loading = true;
      let obj = {statusId : Constants.ClientInvoiceStatus.New, updatedBy:user.id, isReturned:true};
      await this.updateRecord(this.clientInvoiceId, obj, 'clientInvoices');
      this.$Message.success('Client Invoice updated successfully!');
      this.loading = false;
      this.closeDialog();
    },
    closeDialog(){
      this.$refs['charges-summary-comp'].resetCharges();
      this.$emit('update:clientInvoiceId', null);
      this.$emit('update:dialog', false);
    }
  }
}
</script>

<style scoped>
.drawer-footer{
  position: fixed;
  bottom: 20px;
  width: 100%;
  background: #fff;
  border-top: 1px solid #e8eaec;
  padding: 12px;
  margin: 0 0 -20px -16px;
  z-index: 4;
}
.close-btn{
  margin-left: 10px;
}
</style>


